// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_5y-6";
export var headerCell = "_5y-2";
export var rowWrapper = "_5y-4";
export var stickyAggregationCell = "_5y-a";
export var stickyAggregationRow = "_5y-7";
export var stickyColumnCell = "_5y-9";
export var stickyColumnHeaderCell = "_5y-8";
export var table = "_5y-1";
export var virtualRowWrapper = "_5y-5";
export var virtualTableContainer = "_5y-0";
export var white = "_5y-3";